import React, { useEffect, useRef } from 'react'

const FlyingCircles = ({ circles }) => {
	const canvasRef = useRef(null)

	useEffect(() => {
		const canvas = canvasRef.current
		const ctx = canvas.getContext('2d')

		// Устанавливаем размеры canvas в пикселях
		canvas.width = window.innerWidth
		canvas.height = window.innerHeight

		// Синхронизируем стиль с размерами
		canvas.style.width = `${window.innerWidth}px`
		canvas.style.height = `${window.innerHeight}px`

		const animate = () => {
			ctx.clearRect(0, 0, canvas.width, canvas.height)

			circles.forEach((circle) => {
				ctx.beginPath()

				const gradient = ctx.createLinearGradient(
					circle.x,
					circle.y + circle.radius,
					circle.x,
					circle.y - circle.radius
				)

				gradient.addColorStop(0, '#147B55')
				gradient.addColorStop(1, '#A3E5CD')
				ctx.fillStyle = gradient

				ctx.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2)
				ctx.fill()

				// Обновляем координаты для анимации
				circle.x += circle.dx
				circle.y += circle.dy

				// Проверка столкновений с краями экрана
				if (circle.x + circle.radius > canvas.width || circle.x - circle.radius < 0) {
					circle.dx *= -1
				}
				if (circle.y + circle.radius > canvas.height || circle.y - circle.radius < 0) {
					circle.dy *= -1
				}
			})

			requestAnimationFrame(animate)
		}

		animate()

		return () => {
			// Чистим анимацию при размонтировании
			cancelAnimationFrame(animate)
		}
	}, [circles])

	return (
		<canvas
			ref={canvasRef}
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				zIndex: -1,
				pointerEvents: 'none',
			}}
		/>
	)
}

export default FlyingCircles
